import Lenis from 'lenis';

export class Interactions {
  constructor () {
    const { $gsap, $ScrollTrigger } = useNuxtApp();
    this.gsap = $gsap;
    this.ScrollTrigger = $ScrollTrigger;

    this.lenis = null;

    if (typeof window !== 'undefined') {
      this.ScrollTrigger.normalizeScroll();
    }
  }

  createSmoothScroll () {
    this.lenis = new Lenis({
      lerp: 0.08,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    this.lenis.on('scroll', () => this.ScrollTrigger.update());

    this.gsap.ticker.add((time) => {
      this.lenis.raf(time * 1000);
    });

    this.gsap.ticker.lagSmoothing(0);
  }

  stopLenis () {
    this.lenis.stop();
  }

  startLenis () {
    this.lenis.start();
  }

  destroyLenis () {
    this.lenis.stop();
    this.lenis.destroy();
  }
}
